export const getCancellationCopy = (isEducationDomain = false) => {
    if (isEducationDomain) {
        return {
            auditReason: 'Enrollment cancelled by student.',
            cancelledSuccess: 'Enrollment has been cancelled successfully.',
            zelleBlocked: 'Zelle-paid enrollments cannot be cancelled online. Please contact support.',
            refundFailed: 'Failed to process the enrollment refund.',
            cancellationFailed: 'Failed to cancel the enrollment.'
        };
    }

    return {
        auditReason: 'Booking cancelled by user.',
        cancelledSuccess: 'Booking has been cancelled successfully.',
        zelleBlocked: 'Zelle bookings cannot be cancelled from this page. Please contact support.',
        refundFailed: 'Failed to process refund.',
        cancellationFailed: 'Failed to process cancellation.'
    };
};
